// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".policy-text[data-v-054c91ed] {\n  max-height: 300px;\n  overflow-y: auto;\n}\n.title-left[data-v-054c91ed] {\n  display: flex;\n  flex: 1;\n  align-items: center;\n}\n.title-text[data-v-054c91ed] {\n  color: inherit;\n  max-width: calc(100% - 250px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-right: 14px;\n  text-decoration: none;\n}\n", ""]);
// Exports
module.exports = exports;
